var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"width":"900"},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},[_c('v-card',{staticClass:"iframeWrapper",attrs:{"height":"800"}},[_c('iframe',{attrs:{"srcdoc":_vm.html}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }